// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-account-form[data-v-603fda6d] .password-input{display:none}.create-account-form[data-v-603fda6d] .create-account-form-bottom{padding-top:1.2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
